import { createBlueprint as p } from "@made-people/blueprint";
const o = p({
  slots: {
    wrapper: "",
    grid: "group in-grid grid [&>*]:col-span-1"
  },
  variants: {
    columns: {
      1: { grid: "grid-cols-1" },
      2: { grid: "grid-cols-2" },
      3: { grid: "grid-cols-3" },
      4: { grid: "grid-cols-4" },
      5: { grid: "grid-cols-5" },
      6: { grid: "grid-cols-6" },
      auto: { grid: "grid-cols-[repeat(var(--grid-columns),minmax(0,1fr))]" }
    },
    gapX: {
      none: { grid: "gap-x-component-spacing-none" },
      "5xs": { grid: "gap-x-component-spacing-5xs" },
      "4xs": { grid: "gap-x-component-spacing-4xs" },
      "3xs": { grid: "gap-x-component-spacing-3xs" },
      "2xs": { grid: "gap-x-component-spacing-2xs" },
      xs: { grid: "gap-x-component-spacing-xs" },
      sm: { grid: "gap-x-component-spacing-sm" },
      md: { grid: "gap-x-component-spacing-md" },
      lg: { grid: "gap-x-component-spacing-lg" },
      xl: { grid: "gap-x-component-spacing-xl" },
      "2xl": { grid: "gap-x-component-spacing-2xl" },
      "3xl": { grid: "gap-x-component-spacing-3xl" },
      "4xl": { grid: "gap-x-component-spacing-4xl" },
      "5xl": { grid: "gap-x-component-spacing-5xl" },
      "6xl": { grid: "gap-x-component-spacing-6xl" },
      "7xl": { grid: "gap-x-component-spacing-7xl" }
    },
    gapY: {
      none: { grid: "gap-y-component-spacing-none" },
      "5xs": { grid: "gap-y-component-spacing-5xs" },
      "4xs": { grid: "gap-y-component-spacing-4xs" },
      "3xs": { grid: "gap-y-component-spacing-3xs" },
      "2xs": { grid: "gap-y-component-spacing-2xs" },
      xs: { grid: "gap-y-component-spacing-xs" },
      sm: { grid: "gap-y-component-spacing-sm" },
      md: { grid: "gap-y-component-spacing-md" },
      lg: { grid: "gap-y-component-spacing-lg" },
      xl: { grid: "gap-x-component-spacing-xl" },
      "2xl": { grid: "gap-y-component-spacing-2xl" },
      "3xl": { grid: "gap-y-component-spacing-3xl" },
      "4xl": { grid: "gap-y-component-spacing-4xl" },
      "5xl": { grid: "gap-y-component-spacing-5xl" },
      "6xl": { grid: "gap-y-component-spacing-6xl" },
      "7xl": { grid: "gap-y-component-spacing-7xl" }
    },
    spacingY: {
      none: { wrapper: "my-component-spacing-none" },
      "5xs": { wrapper: "my-component-spacing-5xs" },
      "4xs": { wrapper: "my-component-spacing-4xs" },
      "3xs": { wrapper: "my-component-spacing-3xs" },
      "2xs": { wrapper: "my-component-spacing-2xs" },
      xs: { wrapper: "my-component-spacing-xs" },
      sm: { wrapper: "my-component-spacing-sm" },
      md: { wrapper: "my-component-spacing-md" },
      lg: { wrapper: "my-component-spacing-lg" },
      xl: { wrapper: "my-component-spacing-xl" },
      "2xl": { wrapper: "my-component-spacing-2xl" },
      "3xl": { wrapper: "my-component-spacing-3xl" },
      "5xl": { wrapper: "my-component-spacing-5xl" },
      "6xl": { wrapper: "my-component-spacing-6xl" },
      "7xl": { wrapper: "my-component-spacing-7xl" }
    },
    spacingX: {
      none: { wrapper: "px-component-spacing-none w-full box-border" },
      "5xs": { wrapper: "px-component-spacing-5xs w-full box-border" },
      "4xs": { wrapper: "px-component-spacing-4xs w-full box-border" },
      "3xs": { wrapper: "px-component-spacing-3xs w-full box-border" },
      "2xs": { wrapper: "px-component-spacing-2xs w-full box-border" },
      xs: { wrapper: "px-component-spacing-xs w-full box-border" },
      sm: { wrapper: "px-component-spacing-sm w-full box-border" },
      md: { wrapper: "px-component-spacing-md w-full box-border" },
      lg: { wrapper: "px-component-spacing-lg w-full box-border" },
      xl: { wrapper: "px-component-spacing-xl w-full box-border" },
      "2xl": { wrapper: "px-component-spacing-2xl w-full box-border" },
      "3xl": { wrapper: "px-component-spacing-3xl w-full box-border" },
      "4xl": { wrapper: "px-component-spacing-4xl w-full box-border" },
      "5xl": { wrapper: "px-component-spacing-5xl w-full box-border" },
      "6xl": { wrapper: "px-component-spacing-6xl w-full box-border" },
      "7xl": { wrapper: "px-component-spacing-7xl w-full box-border" }
    },
    maxWidth: {
      none: { grid: "max-w-component-max-w-none" },
      sm: { grid: "max-w-component-max-w-sm ml-auto mr-auto" },
      md: { grid: "max-w-component-max-w-md ml-auto mr-auto" },
      lg: { grid: "max-w-component-max-w-lg ml-auto mr-auto" },
      xl: { grid: "max-w-component-max-w-xl ml-auto mr-auto" }
    }
  },
  defaultVariants: {
    columns: {
      initial: "1",
      lg: "2"
    },
    spacingY: {
      initial: "xs",
      lg: "md"
    },
    spacingX: {
      initial: "sm",
      lg: "md"
    },
    gapY: {
      initial: "xs",
      lg: "md"
    },
    gapX: {
      initial: "xs",
      lg: "md"
    },
    maxWidth: "none"
  }
});
export {
  o as gridBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
